import { type RefOrGetter } from '@/helpers'
import { useRedirect } from 'wucdbm-vite-vue-ssr'
import { toValue, watch, type WatchHandle } from 'vue'

type RoutePathWatcher = () => Promise<WatchHandle>

export function usePageWatcher(
    currentPage: RefOrGetter<number>,
    pageCount: RefOrGetter<number>,
    getPathFunction: () => string,
    code: 301 | 302
): RoutePathWatcher {
    const redirect = useRedirect()

    return async (): Promise<WatchHandle> => {
        const redirectIfNeeded = async ([current, total]: [number, number]) => {
            if (total && current > total) {
                await redirect(getPathFunction(), code)
            }
        }

        const handle = watch([currentPage, pageCount], redirectIfNeeded)

        await redirectIfNeeded([toValue(currentPage), toValue(pageCount)])

        return handle
    }
}
